import { useEffect, useState } from "react";
import "../blocks/favoriteCard/favoriteCard.css";
import { getYoutubeThumbnail } from "../utils/youtube";
import { isDirectVideoFile, getVimeoThumbnail } from "../utils/videoEmbed";

const FavoriteCard = ({ favorite, onDelete }) => {
  const { type, url, title } = favorite;
  const isDirectVideo = type === "video" && isDirectVideoFile(url);
  const youtubeThumbnail = type === "video" ? getYoutubeThumbnail(url) : null;
  const [vimeoThumbnail, setVimeoThumbnail] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (type === "video" && !youtubeThumbnail && !isDirectVideo) {
      getVimeoThumbnail(url).then((thumb) => {
        if (!cancelled) setVimeoThumbnail(thumb);
      });
    }
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, type]);

  const coverImage = youtubeThumbnail || vimeoThumbnail;

  return (
    <div className="favoriteCard__item">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="favoriteCard__link"
      >
        {type === "photo" ? (
          <img src={url} className="favoriteCard__image" alt={title || "Favorite photo"} />
        ) : (
          <div className="favoriteCard__video">
            {coverImage ? (
              <img src={coverImage} className="favoriteCard__image" alt={title || "Favorite video"} />
            ) : isDirectVideo ? (
              <video
                className="favoriteCard__image"
                src={url}
                muted
                preload="metadata"
              />
            ) : (
              <div className="favoriteCard__video-placeholder" />
            )}
            <span className="favoriteCard__play-icon" aria-hidden="true" />
          </div>
        )}
      </a>
      <div className="favoriteCard__description">
        {title && <h2 className="favoriteCard__title">{title}</h2>}
        <button
          type="button"
          className="favoriteCard__delete-button"
          onClick={() => onDelete(favorite)}
          aria-label="Delete favorite"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default FavoriteCard;
